import React from 'react';
import { Box } from '@mui/material';
import sharedStyles from '../../../../../IndeedIntegration/AdEditor/useStyles';
import { stepPropTypes } from '../../../../../IndeedIntegration/AdEditor/Steps/types';
import renderHTML from 'react-render-html';

const MAX_KEY_SELLING_POINTS = 3;

function Step3({ answers }) {
  const sharedClasses = sharedStyles();

  return (
    <Box className={sharedClasses.stepContainer}>
      <h4>Preview Ad</h4>

      <div className={sharedClasses.previewContainer}>
        <div className={sharedClasses.previewTitle}>{`${answers.title} (${answers.workType})`}</div>
        <div
          className={sharedClasses.previewDetails}
        >{`${answers.address} (${answers.workLocation})`}</div>
        <div
          className={sharedClasses.previewDetails}
        >{`$${answers.payRangeLow}-$${answers.payRangeHigh}`}</div>
        {answers.benefits && (
          <div className={sharedClasses.previewDetails}>
            {answers.benefits.map((benefit, index) => (
              <span key={index}>
                {benefit}
                {index < answers.benefits.length - 1 && ' • '}
              </span>
            ))}
          </div>
        )}
        {answers.featured && (
          <Box sx={{ marginTop: '1rem' }}>
            <div className={sharedClasses.previewDetails}>Featured Job on Viewjobs</div>
            <br />
            <div className={sharedClasses.previewDetails}>{answers.jobPreview.summary}</div>
            {Array.from({ length: MAX_KEY_SELLING_POINTS }).map((_, index) => (
              <div className={sharedClasses.previewDetails} key={index}>
                • {answers.jobPreview[`key${index + 1}`]}
              </div>
            ))}
          </Box>
        )}
        <div className={sharedClasses.previewContent}>{renderHTML(answers.description)}</div>
      </div>
    </Box>
  );
}

Step3.propTypes = stepPropTypes;

export default Step3;
